// PingingWeb.jsx
import PingingDataTable from "../../components/PingingDataTable/PingingDataTable";
const PingingWeb = () => {
  return (
    <PingingDataTable
      title="Pinging Report - Lesson Pages"
      apiEndpoint="/pinging-page"
      defaultValue="web_all"
      showVideoColumns={false}
      showPlayVideo={false}
      type="ping"
      pingType="web"
      toolId={5}
    />
  );
};

export default PingingWeb;
